import {
  LOGOUT, SET_LOGIN_EMAIL, SET_LOGIN_MEDIUM
} from './types';

export function setLoginEmail(loginEmail) {
  return {
    type: SET_LOGIN_EMAIL,
    payload: { loginEmail }
  };
}

export function setLoginMedium(loginMedium) {
  return {
    type: SET_LOGIN_MEDIUM,
    payload: { loginMedium }
  };
}

export function logout() {
  return {
    type: LOGOUT,
    payload: {}
  };
}
